import { PublicClientApplication } from "@azure/msal-browser";
import { MSCLIENT_ID, REDIRECTURL } from "./config";

export const msalConfig = {
  auth: {
    clientId: MSCLIENT_ID,
    authority: "https://login.microsoftonline.com/common", 
    redirectUri: REDIRECTURL,  // same as Azure
  }
};



export const msalInstance = new PublicClientApplication(msalConfig);
